import { useCallback, useRef } from 'react'

import { useQueryClient } from '@tanstack/react-query'
import styled from 'styled-components'

import useExecuteOnClientNavigation from '@hooks/useExecuteOnClientNavigation'

const StyledDrawerPortalContainer = styled.div``

const DrawerPortalContainer = () => {
  const queryClient = useQueryClient()

  const drawerContainerRef = useRef<HTMLDivElement | null | undefined>(null)

  const setDrawerContainerRef = useCallback<
    (node?: HTMLDivElement | null | undefined) => void
  >(
    (node) => {
      if (node) {
        queryClient.setQueryData(['drawer-portal-container-node-ref'], node)
        queryClient.invalidateQueries({
          queryKey: ['drawer-portal-container-node-ref'],
          exact: true,
        })
        drawerContainerRef.current = node
      }
    },
    [queryClient]
  )

  const resetDrawerContainerRef = useCallback(() => {
    if (drawerContainerRef.current) {
      setDrawerContainerRef(drawerContainerRef.current)
    }
  }, [setDrawerContainerRef])

  useExecuteOnClientNavigation(resetDrawerContainerRef)

  return <StyledDrawerPortalContainer ref={setDrawerContainerRef} />
}

export default DrawerPortalContainer
